import React from 'react';
import FloatingCTA from '../components/FloatingCTA';
import './MiningRace.css';

function MiningRace() {
  return (
    <div className="miningrace-page" data-testid="miningrace-page">
      <FloatingCTA />

      <section className="page-hero">
        <div className="container">
          <h1>Mining Race</h1>
          <p className="hero-subtitle">Einfaches, effizientes Bitcoin-Mining ohne eigene Technik/Geräte</p>
        </div>
      </section>

      {/* Videos Section */}
      <section className="videos-section section">
        <div className="container">
          <div className="videos-grid">
            <div className="video-card">
              <video controls className="product-video">
                <source src="https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/7scrv4cs_MR%20Video%201%20why.mp4" type="video/mp4" />
              </video>
            </div>
            <div className="video-card">
              <video controls className="product-video">
                <source src="https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/u57xxukj_MR%20Video%202%20why.mp4" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="content-section section">
        <div className="container">
          <div className="content-wrapper">
            <div className="intro-section">
              <h2>Warum Mining Race?</h2>
              <p className="intro-text">
                Die Antwort ist einfach: transparent, leicht verständlich und nachhaltig. Während viele Krypto-Angebote kompliziert sind, ist Mining Race klar strukturiert und für jeden umsetzbar.
              </p>
            </div>

            <div className="content-block">
              <p>
                Mining Race ist eine transparente, leicht verständliche und nachhaltige Möglichkeit, in das Bitcoin Mining einzusteigen. Im Gegensatz zu vielen komplexen und undurchsichtigen Krypto-Angeboten bietet Mining Race eine klare Struktur, die für nahezu jeden zugänglich ist.
              </p>
              <p>
                Das Bitcoin Mining bei Mining Race funktioniert ohne den Bedarf an eigener Hardware oder technischem Know-how. Die Nutzer profitieren von professionell betriebenen, energieeffizienten Mining-Anlagen, die den Betrieb rund um die Uhr gewährleisten. Dadurch entsteht eine kontinuierliche und zuverlässige Ertragsquelle, ohne dass man sich um die technischen Details kümmern muss.
              </p>
            </div>

            {/* Rotating Bitcoin */}
            <div className="rotating-bitcoin-section">
              <img 
                src="https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/03l9lukj_pngtree-gold-bitcoin-cryptocurrency-coin-3d-illustration-png-image_13630971.png"
                alt="Bitcoin"
                className="bitcoin-large-rotating"
              />
            </div>

            <div className="feature-section">
              <h3>Deine Vorteile</h3>
              <div className="features-grid">
                <div className="feature-item">
                  <div className="feature-icon">💡</div>
                  <h4>Einfach & Verständlich</h4>
                  <p>Teilnehmer erhalten Zugang zu aktiven Telegram-Gruppen, in denen alle relevanten Informationen bereitgestellt werden. Verständliche Videos und begleitende Unterlagen erklären Schritt für Schritt die Abläufe, wodurch Sicherheit und Klarheit von Anfang an garantiert sind.</p>
                </div>
                <div className="feature-item">
                  <div className="feature-icon">🛒</div>
                  <h4>Bequem wie Online-Shopping</h4>
                  <p>Die Nutzung von Mining Race ist so einfach und bequem, dass sie fast mit Onlineshopping vergleichbar ist: Produkte auswählen, bestätigen und das Mining beginnt. Der Prozess ist so gestaltet, dass die Teilnehmer in ihrem eigenen Tempo und ohne Hürden starten können.</p>
                </div>
                <div className="feature-item">
                  <div className="feature-icon">🌱</div>
                  <h4>Nachhaltig & Energieeffizient</h4>
                  <p>Mining Race legt großen Wert auf Nachhaltigkeit und Energieeffizienz. Die Mining-Anlagen nutzen moderne Technologien, um den Energieverbrauch zu optimieren und Umweltbelastungen zu minimieren.</p>
                </div>
              </div>
            </div>

            <div className="cta-box">
              <h2>Bereit, mehr zu erfahren? Lass uns diesen Weg gemeinsam gehen!</h2>
              <p>
                Insgesamt ermöglicht Mining Race einen einfachen Einstieg in die Welt des Bitcoin Minings – sicher, transparent und nachhaltig – und bietet damit eine echte Chance, passiv Einkommen zu generieren und sich finanziell unabhängiger aufzustellen.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section section">
        <div className="container">
          <div className="cta-content">
            <h2>Bereit, den ersten Schritt zu machen?</h2>
            <p>Werde Teil unserer Gemeinschaft und starte deine Reise zur finanziellen Freiheit.</p>
            <div className="qr-code-container">
              <a 
                href="/#cta-section" 
                className="qr-code-link"
                data-testid="foerderer-cta-link"
              >
                Jetzt persönlichen Förderer finden →
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default MiningRace;
